import { Component } from 'react';
import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';
import { language } from 'utils/i18n';
import { loadScript } from 'utils/loadScript';

/**
 * @description
 * 接入WebWidget
 */

interface IWebWidgetProps {
    isLogin?: boolean;
    key?: number;
    isMarscoAccount: boolean;
    uuid: number;
    userHash: string;
}

// intercom appId
const appId = 'gcu2chnc';
const languageMap = {
    zh_CN: 'zh-CN',
    en_US: 'en'
};

class WebWidget extends Component<IWebWidgetProps> {
    public componentDidMount() {
        this.getServiceSDK();
    }

    async getServiceSDK() {
        const { userHash, isMarscoAccount, uuid } = this.props;

        const url = !isMarscoAccount
            ? 'https://static.zdassets.com/ekr/snippet.js?key=5e7ddc25-9b92-47a8-ac43-95035981b634'
            : `https://widget.intercom.io/widget/${appId}`;

        try {
            await loadScript(true, url);

            if (!isMarscoAccount) {
                this.setting();
            } else {
                let userInfo: {
                    name?: string;
                    user_id?: number;
                    user_hash?: string;
                } = {
                    user_id: uuid,
                    user_hash: userHash
                };

                if (security.currentProcessStatus !== 'UNACCOUNT') {
                    try {
                        // 经server确认, 此接口需要customerId但无需加密，用来匹配userId更加准确。
                        const { data } = await http.get(API.CUSTOMER.getProfile(), {
                            params: {
                                customer_id: security.currentCustomerId
                            }
                        });

                        userInfo.name = data.first_name;
                    } catch {}
                }

                window.Intercom?.('boot', {
                    app_id: appId,
                    language_override: languageMap[language],
                    ...userInfo
                });
            }
        } catch (err) {}
    }

    setting = async () => {
        window.zE?.('webWidget', 'setLocale', 'en-US');

        window.zESettings = {
            webWidget: {
                contactOptions: {
                    enabled: true,
                    contactButton: { '*': __('Get in touch') },
                    chatLabelOnline: { '*': __('Chat with us') },
                    chatLabelOffline: { '*': __('Chat is unavailable') },
                    contactFormLabel: { '*': __('Leave us a message') }
                },
                contactForm: {
                    attachments: true
                },
                launcher: {
                    chatLabel: {
                        '*': __('Chat')
                    },
                    mobile: {
                        labelVisible: true
                    }
                },
                chat: {
                    suppress: false,
                    attachments: true,
                    notifications: {
                        mobile: {
                            disable: false
                        }
                    },
                    prechatForm: {
                        greeting: {
                            '*': __('Please fill out the form below to chat with us')
                        }
                    }
                }
            }
        };

        if (security.isLogin) {
            Object.assign(window.zESettings.webWidget, {
                authenticate: {
                    chat: {
                        jwtFn: async callback => {
                            try {
                                const { data } = await http.get(API.SUPPORT.getWebWidget());

                                callback(data.jwt);
                            } catch (error) {
                                // 如果有报错按照未登录按照处理
                                // Toast.show(error);
                            }
                        }
                    }
                }
            });
        }
    };

    // componentDidUpdate(prevProps) {
    //     // 用户登录退出时需要更新webWidget配置，使用官方提供的updateSetting方法，测试发现只能更新常规配置，对安全验证的更新无效,官网解释是“There is no transition phase for a visitor to move from non-authenticated to authenticated in the same session.”，
    //     // 访问者在同一会话中从非身份验证移动到身份验证没有过渡阶段，需要在身份验证后重新加载webWidget，所以在这进行页面刷新.
    //     // 同时如果验证用户聊天后退出，webWidget身份验证暂时失效，官网回答：the widget will disconnect the visitor after 15 seconds based on the timeout value and they would need to be authenticated again via the client.
    //     // webWidget机制是在15s后根据超时值断开访问者，此时webWidget不会要求用户填写身份信息
    //     if (prevProps.isLogin !== this.props.isLogin) {
    //         window.zE?.('webWidget', 'logout');
    //         window.Intercom?.('shutdown');
    //         window.location.reload();
    //     }
    // }

    // componentWillUnmount() {
    //     window.zE('webWidget', 'logout');
    //     delete window.zE;
    //     delete window.zESettings;
    // }

    render() {
        return null;
    }
}

export default WebWidget;
